import { Component, Input } from '@angular/core';
import { SchemaRouteStationInfo } from 'src/app/project/project-schema/shared/interfaces/schema-route-station-info.interface';
import { ProjectRouteStation } from '../../shared/interfaces/project-route-station.interface';
import { DeviceService } from 'src/app/device/shared/services/device.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { Subscription } from 'rxjs';
import { DataEndChannel } from '../../shared/interfaces/data-end-channel.interface';
import { ProjectDataService } from '../../shared/services/project-data.service';
import { LocalBusTypeEnum } from '../../project-settings/data-end-channel-table/local-bus-type.enum';
import { SmartMicroCommand, SmartMicroStatus } from 'src/app/device/shared/interfaces/smart-micro-command.interface';

@Component({
  selector: 'avs-test-area-smart-micro',
  templateUrl: './test-area-smart-micro.component.html',
  styleUrls: ['./test-area-smart-micro.component.css']
})
export class TestAreaSmartMicroComponent {
  @Input() schemaInfo?: SchemaRouteStationInfo;
  @Input() activeStation?: ProjectRouteStation;
  public dataEndChannelsSubscription?: Subscription;
  public isLocalBusAddressDropdownOpen: boolean = false;
  public selectedLocalBusAddress?: SelectInput;
  public localBusAddressSelect: SelectInput[] = [];
  public isLearningStatusDropdownOpen: boolean = false;
  public isAppStatusDropdownOpen: boolean = false;
  public readonly statusSelect: SelectInput[] = [
    { name: 'Aus', id: SmartMicroStatus.Off },
    { name: 'An', id: SmartMicroStatus.On },
  ];
  public selectedLearningStatus?: SelectInput;
  public selectedAppStatus?: SelectInput;

  constructor(private deviceService: DeviceService,
    private alertService: AlertService,
    public projectDataService: ProjectDataService
  ) {
    this.dataEndChannelsSubscription = projectDataService.dataEndChannels.subscribe(endChannels => {
      this.getLocalBusAddressSelect(endChannels)

    });
  }

  public onLocalBusAddressItemClicked(selectItem: SelectInput): void {
    this.selectedLocalBusAddress = selectItem;
    this.isLocalBusAddressDropdownOpen = false
  }

  public onLocalBusAddressDropdownClicked(): void {
    this.isLocalBusAddressDropdownOpen = !this.isLocalBusAddressDropdownOpen;
  }

  public onLearningStatusItemClicked(item: SelectInput): void {
    this.selectedLearningStatus = item;
    this.isLearningStatusDropdownOpen = false;
  }

  public onAppStatusItemClicked(item: SelectInput): void {
    this.selectedAppStatus = item;
    this.isAppStatusDropdownOpen = false;
  }

  public onLearningStatusDropdownClicked(): void {
    this.isLearningStatusDropdownOpen = !this.isLearningStatusDropdownOpen;
  }

  public onAppStatusDropdownClicked(): void {
    this.isAppStatusDropdownOpen = !this.isAppStatusDropdownOpen;
  }

  public onLearnSaveBtnClicked(): void {
    const command = this.createCommand(this.selectedLearningStatus);
    if (!command) return;

    this.deviceService.learnSmartMicro(command).subscribe(() => {
      this.alertService.alert("SmartMicro-Anlernen erfolgreich gespeichert", AlertTypes.success)
    })
  }

  public onAppStatusSaveBtnClicked(): void {
    const command = this.createCommand(this.selectedAppStatus);
    if (!command) return;

    this.deviceService.setSmartMicroEVAAppStatus(command).subscribe(() => {
      this.alertService.alert("SmartMicro EVA App-Status erfolgreich gespeichert", AlertTypes.success)
    })
  }

  private getLocalBusAddressSelect(endChannels: DataEndChannel[]): void {
    const smartMicroLocalBusAddresses = new Set(
      endChannels
        .filter(channel => channel.localbusAddress === LocalBusTypeEnum.SmartMicro)
        .map(channel => channel.localbusAddress)
    );

    this.localBusAddressSelect = Array.from(smartMicroLocalBusAddresses).map(localBusAddress => ({
      name: `Localbus-Adresse ${localBusAddress}`,
      id: localBusAddress,
    }));

    this.selectedLocalBusAddress = this.localBusAddressSelect.length === 1
      ? this.localBusAddressSelect[0]
      : undefined;
  }

  private createCommand(status: SelectInput | undefined): SmartMicroCommand | undefined {
    const localBusAddress = this.selectedLocalBusAddress?.id;
    const selectedStatus = status?.id;

    if (!this.activeStation || typeof localBusAddress !== 'number' || typeof selectedStatus !== 'number') {
      return undefined;
    }

    return {
      guid: this.activeStation.id,
      deKanal: localBusAddress,
      status: selectedStatus as SmartMicroStatus,
    };
  }
}
